<template>
  <component v-if="isCustomIcon" :is="customIcons[name]" class="icon custom" />
  <i v-else class="icon material-icons">{{ name }}</i>
</template>

<script>
import DragonballZIcon from '../icons/DragonballZIcon';
import FortniteIcon from '../icons/FortniteIcon';
import LadderIcon from '../icons/LadderIcon';
import MagicIcon from '../icons/MagicIcon';
import MetazooIcon from '../icons/MetazooIcon';
import OnePieceIcon from '../icons/OnePieceIcon';
import PsaImageIcon from '../icons/PsaImageIcon';
import SoftballIcon from '../icons/SoftballIcon';
import StarWarsIcon from '../icons/StarWarsIcon';
import UfcIcon from '../icons/UfcIcon';
import YugiohIcon from '../icons/YugiohIcon';

export default {
  props: {
    name: String,
  },

  data() {
    return {
      customIcons: {
        cl_dragonballz: DragonballZIcon,
        cl_fortnite: FortniteIcon,
        cl_ladder: LadderIcon,
        cl_metazoo: MetazooIcon,
        cl_mtg: MagicIcon,
        cl_onepiece: OnePieceIcon,
        cl_psa_image: PsaImageIcon,
        cl_softball: SoftballIcon,
        cl_starwars: StarWarsIcon,
        cl_ufc: UfcIcon,
        cl_yugioh: YugiohIcon,
      },
    };
  },

  computed: {
    isCustomIcon() {
      return Object.keys(this.customIcons).includes(this.name);
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  font-size: var(--icon-size, 24px);
}

.custom {
  width: var(--icon-size, 24px);
  height: var(--icon-size, 24px);
}
</style>
